'use client';

import { Loader2 } from 'lucide-react';

interface NavigationLoadingOverlayProps {
  message?: string;
  isLoading: boolean;
}

export function NavigationLoadingOverlay({
  message = 'Loading...',
  isLoading
}: NavigationLoadingOverlayProps) {
  if (!isLoading) return null;

  return (
    <div className="bg-background/80 absolute inset-0 z-50 flex items-center justify-center backdrop-blur-xs">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="text-primary h-8 w-8 animate-spin" />
        <p className="text-muted-foreground text-sm">{message}</p>
      </div>
    </div>
  );
}
